import { render } from "./ParcoursOMEGAPage.vue?vue&type=template&id=11e801d5"
import script from "./ParcoursOMEGAPage.vue?vue&type=script&lang=js"
export * from "./ParcoursOMEGAPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__